import { Observable } from 'rxjs'
import { Merchant, FileObject, AccountModel, BookingOffice, MerchantEmailConfig } from "../../models"
import { Query, MerchantApi } from "../../services"
import { MerchantActions } from './merchant.actions';
export interface MerchantState {
	merchantList: Merchant[],
	merchant: Merchant,
	merchantConfigPreviewFileObject: FileObject,
	merchantConfigSavedFileUrl: string,
	selectedMerchantAccount: AccountModel,
	merchantAccounts: AccountModel[],
	bookingOffices: BookingOffice[],
	selectedMerchantEmailConfigUUID: string,
	merchantEmailConfigs: MerchantEmailConfig[]
};

const initialState: MerchantState  = {
	merchantList: [],
	merchant: null,
	merchantConfigPreviewFileObject: null,
	merchantConfigSavedFileUrl: null,
	selectedMerchantAccount: null,
	merchantAccounts: null,
	bookingOffices: null,
	selectedMerchantEmailConfigUUID: null,
	merchantEmailConfigs: null,
}

export const merchantsReducer = (state = initialState, action): MerchantState => {
	switch (action.type) {
		case MerchantActions.SET_MERCHANT_LOGO: {
			return Object.assign({}, state, {
				merchantConfigPreviewFileObject: action.payload
			})
		}
		case MerchantActions.UNSET_MERCHANT_LOGO: {
			return Object.assign({}, state, {
				merchantConfigPreviewFileObject: null
			})
		}
		case MerchantActions.LOAD_MERCHANT_LIST_SUCCESS: {
			return Object.assign({}, state,
				{
					merchantList: action.payload
				})
		}
		case MerchantActions.DELETE_MERCHANT_LOGO_SUCCESS: {
			return Object.assign({}, state,
				{
					merchantConfigSavedFileUrl: null,
					merchantConfigPreviewFileObject: null
				})
		}
		case MerchantActions.SAVE_MERCHANT_CONFIG_SUCCESS: {
			let url = getLogoUrl(action.payload)
			return Object.assign({}, state, {
				merchantConfigPreviewFileObject: null,
				merchantConfigSavedFileUrl: url,
				merchant: action.payload,
			})
		}

		case MerchantActions.LOAD_MERCHANT_BY_MERCHANT_ID_SUCCSESS: {
			let url = getLogoUrl(action.payload)
			return Object.assign({}, state, {
				merchant: action.payload,
				merchantConfigSavedFileUrl: url
			})
		}

		case MerchantActions.MERCHANT_LOADED: {
			return Object.assign({}, state, {
				merchant: action.payload
			})
		}

		case MerchantActions.LOAD_MERCHANT_ACCOUNTS_SUCCESS: {
			return Object.assign({}, state, {
				merchantAccounts: action.payload
			})
		}

		case MerchantActions.MERCHANT_ACCOUNT_LOADED: {
			return Object.assign({}, state, {
				selectedMerchantAccount: action.payload
			})
		}

		case MerchantActions.LOAD_BOOKING_OFFICES_SUCCESS: {
			return Object.assign({}, state, {
				bookingOffices: action.payload
			})
		}

		case MerchantActions.SET_SELECTED_MERCHANT_EMAIL_CONFIG_UUID: {
			return Object.assign({}, state, {
				selectedMerchantEmailConfigUUID: action.payload
			})
		}

		case MerchantActions.LOAD_MERCHANT_EMAIL_CONFIGS_SUCCESS: {
			return Object.assign({}, state, {
				merchantEmailConfigs: action.payload
			})
		}

		default: {
			return state
		}
	}
}

function getLogoUrl(merchant: Merchant) {
	if (merchant && merchant.merchantConfiguration && merchant.merchantConfiguration.merchantLogo) {
		return ZUUL_BACKEND + MerchantApi.merchantLogoURL + "/" + merchant.merchantId + "/logo.img";
	}
	return null;
}



// WEBPACK FOOTER //
// ./src/app/components/merchants/merchant.reducer.ts